import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { DeviceScheduledTasksEffects } from './device-scheduled-tasks.effects';
import { deviceScheduledTasksReducer } from './device-scheduled-tasks.reducer';

export const provideDeviceScheduledTasksStore = () => [
  provideState('deviceScheduledTasks', deviceScheduledTasksReducer),
  provideEffects([DeviceScheduledTasksEffects]),
];
